import React, { useState } from 'react';

import { CheckCircleOutlined, SafetyOutlined } from '@ant-design/icons';
import { useOperatorAuth } from '@contexts/operator/OperatorAuthContext';
import { Button, Card, Result, Spin } from 'antd';
import { useTranslation } from 'react-i18next';
import { Navigate, useNavigate } from 'react-router-dom';

import TotpSettings from '../Profile/TotpSettings';

const TotpSetup = () => {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const { isAuthenticated, loading, operator, checkAuthStatus } = useOperatorAuth();
  const [setupComplete, setSetupComplete] = useState(false);

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '100vh' }}>
        <Spin size="large" />
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  // 已設定完成或不需要設定，導向主頁
  if (!operator?.totp_setup_required && !setupComplete) {
    return <Navigate to="/products" replace />;
  }

  const handleContinue = async () => {
    await checkAuthStatus();
    navigate('/products', { replace: true });
  };

  return (
    <div style={{
      minHeight: '100vh',
      background: '#f5f5f5',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      padding: 24,
    }}>
      <Card
        style={{ maxWidth: 560, width: '100%' }}
        styles={{ body: { padding: '32px 32px 24px' } }}
      >
        <Result
          icon={setupComplete
            ? <CheckCircleOutlined style={{ color: '#52c41a' }} />
            : <SafetyOutlined style={{ color: '#2D5F9F' }} />
          }
          title={setupComplete
            ? t('operator.totp.setup_page.complete_title')
            : t('operator.totp.setup_page.title')
          }
          subTitle={setupComplete
            ? t('operator.totp.setup_page.complete_description')
            : t('operator.totp.setup_page.description')
          }
          style={{ padding: '0 0 24px' }}
        />

        <TotpSettings onEnabled={() => setSetupComplete(true)} />

        <div style={{ textAlign: 'center', marginTop: 24, paddingTop: 16, borderTop: '1px solid #f0f0f0' }}>
          {setupComplete ? (
            <Button
              type="primary"
              onClick={handleContinue}
            >
              {t('operator.totp.setup_page.continue')}
            </Button>
          ) : (
            <Button
              type="link"
              onClick={() => navigate('/products', { replace: true })}
              style={{ color: '#999' }}
            >
              {t('operator.totp.setup_page.skip')}
            </Button>
          )}
        </div>
      </Card>
    </div>
  );
};

export default TotpSetup;
